export const timeSectionColumns = [
  {
    title: "Tramo",
    dataIndex: "tramo",
    key: "tramo",
    ellipsis: true,
    fixed: "left",
    width: 150,
  },
  {
    title: "Llamadas recibidas",
    dataIndex: "recibidas",
    key: "recibidas",
    width: 170,
  },
  {
    title: "Llamadas atendidas",
    dataIndex: "atendidas",
    key: "atendidas",
    width: 170,
  },
  {
    dataIndex: "atendidas_ns",
    key: "atendidas_ns",
    slots: { title: "nsRespondedCallsTitle" },
    width: 220,
  },
  {
    title: "Llamadas abandonadas",
    dataIndex: "abandonadas",
    key: "abandonadas",
    width: 180,
  },
  {
    dataIndex: "tmo",
    key: "tmo",
    slots: { title: "tmoTitle", customRender: "timeCell" },
    width: 100,
  },
  {
    dataIndex: "tme",
    key: "tme",
    slots: { title: "tmeTitle", customRender: "timeCell" },
    width: 100,
  },
  {
    dataIndex: "tiempo_hablado",
    key: "tiempo_hablado",
    slots: { title: "thTitle", customRender: "timeCell" },
    width: 100,
  },
  {
    dataIndex: "tiempo_tipificado",
    key: "tiempo_tipificado",
    slots: { title: "ttTitle", customRender: "timeCell" },
    width: 100,
  },
  {
    title: "% Nivel de atención",
    dataIndex: "nivel_atencion",
    key: "nivel_atencion",
    slots: { customRender: "percentCell" },
    width: 170,
  },
  {
    title: "% Nivel de servicio",
    dataIndex: "nivel_servicio",
    key: "nivel_servicio",
    slots: { customRender: "percentCell" },
    width: 170,
  },
  {
    title: "% Abandono",
    dataIndex: "nivel_abandono",
    key: "nivel_abandono",
    slots: { customRender: "percentCell" },
    width: 170,
  },
];
